<div #top></div>
<div *ngIf="page === Page.CountrySelection">
  <fin-select-input
    [parentForm]="countrySelection"
    [controlName]="'country'"
    [options]="countryOptions$ | async"
    [selectLabelTranslationKey]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.country.placeholder'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.country'"
    (change)="countryChanged(countrySelection.get('country').value)"
  ></fin-select-input>
  <fcom-notification class="mr-xsmall-b">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.notifications.travelAgency' | finLocalization }}
  </fcom-notification>
  <fin-form-input-checkbox
    [parentForm]="countrySelection"
    [controlName]="'noTravelAgency'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.travelAgency'"
  >
  </fin-form-input-checkbox>
  <div class="border-top flex flex--end ms-xxlarge-t ps-xxlarge-t">
    <fcom-button (clickBtn)="nextPage()" [text]="'SERVICE_FORMS.serviceForms.continue' | finLocalization"></fcom-button>
  </div>
</div>

<div *ngIf="page === Page.CompanyInformation">
  <h2 class="ms-small-b font-heading-2">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.companyInformation.title' | finLocalization }}
  </h2>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">
    {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.mandatoryFields' | finLocalization }}
  </span>

  <fcom-text-input
    [parentForm]="companyDetails"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName'"
    [controlName]="'companyName'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName.placeholder'"
  ></fcom-text-input>

  <fcom-text-input
    class="ms-xsmall-b"
    [parentForm]="companyDetails"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.companyId'"
    [controlName]="'businessId'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.companyId.placeholder'"
    [displayMargin]="false"
  ></fcom-text-input>

  <fcom-notification class="ms-xsmall-t ms-xxlarge-b">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.companyId.notification' | finLocalization }}
  </fcom-notification>

  <fcom-text-input
    [parentForm]="companyDetails"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.address'"
    [controlName]="'address'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.address.placeholder'"
  ></fcom-text-input>

  <div class="flex flex--space-between columns-2">
    <div class="column">
      <fcom-text-input
        [parentForm]="companyDetails"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.postalCode'"
        [controlName]="'postalCode'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.postalCode.placeholder'"
      ></fcom-text-input>
    </div>
    <div class="column">
      <fcom-text-input
        [parentForm]="companyDetails"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.city'"
        [controlName]="'city'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.city.placeholder'"
      ></fcom-text-input>
    </div>
  </div>

  <fin-select-input
    [parentForm]="countrySelection"
    [controlName]="'country'"
    [options]="countryOptions$ | async"
    [selectLabelTranslationKey]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.country.placeholder'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.country'"
    (change)="countryChanged(countrySelection.get('country').value)"
  ></fin-select-input>

  <fin-select-input
    [parentForm]="companyDetails"
    [controlName]="'language'"
    [options]="languageOptions$ | async"
    [selectLabelTranslationKey]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.language.placeholder'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.language'"
  ></fin-select-input>

  <fcom-text-input
    [parentForm]="companyDetails"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.customerNumber'"
    [controlName]="'customerNumber'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.customerNumber.placeholder'"
  ></fcom-text-input>

  <div class="flex flex--space-between columns-2">
    <div class="column">
      <fcom-text-input
        [parentForm]="companyDetails"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.budget'"
        [controlName]="'budget'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.budget.placeholder'"
      ></fcom-text-input>
    </div>
    <div class="column">
      <fin-select-input
        [parentForm]="companyDetails"
        [controlName]="'currency'"
        [options]="currencyOptions"
        [selectLabelTranslationKey]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.currency.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.currency'"
      ></fin-select-input>
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="pageNavigator" [ngTemplateOutletContext]="{ currentPage: page }"></ng-container>
</div>

<div *ngIf="page === Page.ContactDetails">
  <h2 class="ms-small-b font-heading-2">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.contactPerson.title' | finLocalization }}
  </h2>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">
    {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.mandatoryFields' | finLocalization }}
  </span>

  <div class="flex flex--space-between columns-2">
    <div class="column">
      <fcom-text-input
        [parentForm]="contactDetails"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName'"
        [controlName]="'firstName'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName.placeholder'"
      ></fcom-text-input>
    </div>
    <div class="column">
      <fcom-text-input
        [parentForm]="contactDetails"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName'"
        [controlName]="'familyName'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName.placeholder'"
      ></fcom-text-input>
    </div>
  </div>
  <div class="flex flex--space-between columns-2">
    <div class="column">
      <fin-select-input
        [parentForm]="contactDetails"
        [controlName]="'phonePrefix'"
        [options]="phonePrefixes$ | async"
        [selectLabelTranslationKey]="
          'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix.unselected'
        "
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix'"
      ></fin-select-input>
    </div>
    <div class="column">
      <fcom-text-input
        [parentForm]="contactDetails"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber'"
        [controlName]="'phoneNumber'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.placeholder'"
      ></fcom-text-input>
    </div>
  </div>
  <fcom-text-input
    [parentForm]="contactDetails"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email'"
    [controlName]="'email'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.placeholder'"
  ></fcom-text-input>
  <fcom-text-input
    [parentForm]="contactDetails"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle'"
    [controlName]="'title'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle.placeholder'"
  ></fcom-text-input>
  <div class="font-body-1 light-type ms-small-b">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.contactPerson.secondaryContactText' | finLocalization }}
  </div>
  <fin-form-input-checkbox
    [parentForm]="secondaryContactDetails"
    [controlName]="'fillSecondaryContact'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.contactPerson.secondaryContactCheckbox'"
  >
  </fin-form-input-checkbox>
  <div *ngIf="secondaryContactDetails.get('fillSecondaryContact').value">
    <h2 class="ms-small-b">
      {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.contactPerson.secondaryContactTitle' | finLocalization }}
    </h2>

    <div class="flex flex--space-between columns-2">
      <div class="column">
        <fcom-text-input
          [parentForm]="secondaryContactDetails"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName'"
          [controlName]="'firstName'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName.placeholder'"
        ></fcom-text-input>
      </div>
      <div class="column">
        <fcom-text-input
          [parentForm]="secondaryContactDetails"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName'"
          [controlName]="'familyName'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName.placeholder'"
        ></fcom-text-input>
      </div>
    </div>
    <div class="flex flex--space-between columns-2">
      <div class="column">
        <fin-select-input
          [parentForm]="secondaryContactDetails"
          [controlName]="'phonePrefix'"
          [options]="phonePrefixes$ | async"
          [selectLabelTranslationKey]="
            'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix.unselected'
          "
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix'"
        ></fin-select-input>
      </div>
      <div class="column">
        <fcom-text-input
          [parentForm]="secondaryContactDetails"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber'"
          [controlName]="'phoneNumber'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.placeholder'"
        ></fcom-text-input>
      </div>
    </div>
    <fcom-text-input
      [parentForm]="secondaryContactDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email'"
      [controlName]="'email'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.placeholder'"
    ></fcom-text-input>
    <fcom-text-input
      [parentForm]="secondaryContactDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle'"
      [controlName]="'title'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle.placeholder'"
    ></fcom-text-input>
  </div>
  <ng-container [ngTemplateOutlet]="pageNavigator" [ngTemplateOutletContext]="{ currentPage: page }"></ng-container>
</div>

<div *ngIf="page === Page.TravelAgencyDetails">
  <h2 class="ms-large-b font-heading-2">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.travelAgency.title' | finLocalization }}
  </h2>
  <span class="block pr-xsmall-b font-body-1 nordic-blue-900-text">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.travelAgency.info' | finLocalization }}
  </span>
  <fin-form-input-checkbox
    [parentForm]="travelAgencyDetails"
    [controlName]="'fillTravelAgency'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.travelAgency.checkbox'"
  >
  </fin-form-input-checkbox>
  <div *ngIf="travelAgencyDetails.get('fillTravelAgency').value">
    <span class="block pr-medium-y font-body-1 nordic-blue-900-text">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.mandatoryFields' | finLocalization }}
    </span>
    <fcom-text-input
      [parentForm]="travelAgencyDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.travelAgencyName'"
      [controlName]="'name'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.travelAgencyName.placeholder'"
    ></fcom-text-input>

    <div class="flex flex--space-between columns-2">
      <div class="column">
        <fcom-text-input
          [parentForm]="travelAgencyDetails"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName'"
          [controlName]="'firstName'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName.placeholder'"
        ></fcom-text-input>
      </div>
      <div class="column">
        <fcom-text-input
          [parentForm]="travelAgencyDetails"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName'"
          [controlName]="'familyName'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName.placeholder'"
        ></fcom-text-input>
      </div>
    </div>

    <div class="flex flex--space-between columns-2">
      <div class="column">
        <fin-select-input
          [parentForm]="travelAgencyDetails"
          [controlName]="'phonePrefix'"
          [options]="phonePrefixes$ | async"
          [selectLabelTranslationKey]="
            'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix.unselected'
          "
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix'"
        ></fin-select-input>
      </div>
      <div class="column">
        <fcom-text-input
          [parentForm]="travelAgencyDetails"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber'"
          [controlName]="'phoneNumber'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.placeholder'"
        ></fcom-text-input>
      </div>
    </div>

    <fcom-text-input
      [parentForm]="travelAgencyDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email'"
      [controlName]="'email'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.placeholder'"
    ></fcom-text-input>

    <fcom-text-input
      [parentForm]="travelAgencyDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.iataNumber'"
      [controlName]="'iataNumber'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.iataNumber.placeholder'"
    ></fcom-text-input>

    <fcom-text-input
      [parentForm]="travelAgencyDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.officeCodes'"
      [controlName]="'officeCodes'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.officeCodes.placeholder'"
    ></fcom-text-input>

    <fcom-text-input
      [parentForm]="travelAgencyDetails"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.pricingCode'"
      [controlName]="'pricingCode'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.pricingCode.placeholder'"
    ></fcom-text-input>

    <span>{{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.bookingSystem.label' | finLocalization }}</span>
    <fin-form-input-checkbox-list
      [parentForm]="asTypedFormGroup(travelAgencyDetails)"
      class="flex--basis-full"
      [controlName]="'bookingSystems'"
      [checkboxList]="bookingSystems"
    ></fin-form-input-checkbox-list>
  </div>

  <ng-container [ngTemplateOutlet]="pageNavigator" [ngTemplateOutletContext]="{ currentPage: page }"></ng-container>
</div>

<div *ngIf="page === Page.Summary">
  <h2 class="ms-medium-b font-heading-2">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.title' | finLocalization }}
  </h2>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.info' | finLocalization }}
  </span>

  <h3 class="font-heading-3">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.companyInformation' | finLocalization }}
  </h3>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName.label' | finLocalization,
      value: companyDetails.get('companyName').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.companyId.label' | finLocalization,
      value: companyDetails.get('businessId').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.address.label' | finLocalization,
      value: companyDetails.get('address').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.postalCode.label' | finLocalization,
      value: companyDetails.get('postalCode').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.city.label' | finLocalization,
      value: companyDetails.get('city').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.country.label' | finLocalization,
      value: selectedCountryCode.name,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.language.label' | finLocalization,
      value:
        'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.language.options.' + companyDetails.get('language').value
        | finLocalization,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.customerNumber.label' | finLocalization,
      value: companyDetails.get('customerNumber').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.budget.label' | finLocalization,
      value: (companyDetails.get('budget').value || '-') + ' ' + companyDetails.get('currency').value,
    }"
  ></ng-container>
  <div class="border-bottom flex flex--end ms-xxlarge-b ps-xxlarge-b">
    <fcom-button
      [text]="'actions.modify' | finLocalization"
      (clickBtn)="modifyPage(Page.CompanyInformation)"
    ></fcom-button>
  </div>

  <h3 class="font-heading-3">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.contactDetails' | finLocalization }}
  </h3>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.CSServiceForms.fields.name.label' | finLocalization,
      value: contactDetails.get('firstName').value + ' ' + contactDetails.get('familyName').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.label' | finLocalization,
      value: getFormattedPhoneNumber(contactDetails.get('phonePrefix').value, contactDetails.get('phoneNumber').value),
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.label' | finLocalization,
      value: contactDetails.get('email').value,
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle.label' | finLocalization,
      value: contactDetails.get('title').value,
    }"
  ></ng-container>

  <div *ngIf="secondaryContactDetails.get('fillSecondaryContact').value">
    <h3 class="font-body-1 mr-small-y">
      {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.secondaryContactDetails' | finLocalization }}
    </h3>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.CSServiceForms.fields.name.label' | finLocalization,
        value: secondaryContactDetails.get('firstName').value + ' ' + secondaryContactDetails.get('familyName').value,
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.label' | finLocalization,
        value: getFormattedPhoneNumber(
          secondaryContactDetails.get('phonePrefix').value,
          secondaryContactDetails.get('phoneNumber').value
        ),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.label' | finLocalization,
        value: secondaryContactDetails.get('email').value,
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle.label' | finLocalization,
        value: secondaryContactDetails.get('title').value,
      }"
    ></ng-container>
  </div>
  <div class="border-bottom flex flex--end ms-xxlarge-b ps-xxlarge-b">
    <fcom-button [text]="'actions.modify' | finLocalization" (clickBtn)="modifyPage(Page.ContactDetails)"></fcom-button>
  </div>

  <h3 class="font-heading-3">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.travelAgencyDetails' | finLocalization }}
  </h3>
  <ng-container
    [ngTemplateOutlet]="summaryField"
    [ngTemplateOutletContext]="{
      header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.travelAgencyName.label' | finLocalization,
      value: travelAgencyDetails.get('name').value,
    }"
  ></ng-container>
  <div *ngIf="travelAgencyDetails.get('fillTravelAgency').value">
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.nameOfContactPerson' | finLocalization,
        value: travelAgencyDetails.get('firstName').value + ' ' + travelAgencyDetails.get('familyName').value,
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.label' | finLocalization,
        value: travelAgencyDetails.get('email').value,
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.label' | finLocalization,
        value: getFormattedPhoneNumber(
          travelAgencyDetails.get('phonePrefix').value,
          travelAgencyDetails.get('phoneNumber').value
        ),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.iataNumber.label' | finLocalization,
        value: travelAgencyDetails.get('iataNumber').value,
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.officeCodes.label' | finLocalization,
        value: travelAgencyDetails.get('officeCodes').value,
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="summaryField"
      [ngTemplateOutletContext]="{
        header: 'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.pricingCode.label' | finLocalization,
        value: travelAgencyDetails.get('pricingCode').value,
      }"
    ></ng-container>
    <div class="mr-xxsmall-b">
      <span class="font-body-1 ms-large-y block">{{
        'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.bookingSystem.label' | finLocalization
      }}</span>
      <ng-container *ngFor="let bookingSystem of travelAgencyDetails.get('bookingSystems').value; let i = index">
        <div *ngIf="bookingSystem" class="ms-xxsmall-t">
          <fcom-icon [name]="SvgLibraryIcon.CHECKMARK" class="icon-medium ms-xsmall-r"></fcom-icon>
          <span class="font-body-1">{{ bookingSystems[i].label + '.label' | finLocalization }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="border-bottom flex flex--end ms-xxlarge-b ps-xxlarge-b">
    <fcom-button
      [text]="'actions.modify' | finLocalization"
      (clickBtn)="modifyPage(Page.TravelAgencyDetails)"
    ></fcom-button>
  </div>

  <h3 class="font-heading-3 mr-small-b">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.confirmation' | finLocalization }}
  </h3>
  <span
    class="font-body-1 mr-small-b block"
    *ngIf="termsLink$ | async as termsLink"
    [innerHTML]="
      'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.confirmationInfo'
        | finLocalization: { link: termsLink }
        | finSafe: 'html'
    "
  ></span>
  <fin-form-input-checkbox
    [parentForm]="reactiveForm"
    [controlName]="'termsAndConditions'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.termsAndConditions'"
    [labelClass]="'label font-body-1 medium-type ms-small-l'"
  >
  </fin-form-input-checkbox>

  <div class="flex flex--end ms-xxlarge-t ps-xxlarge-t border-top">
    <fcom-button
      [loading]="loading"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      [type]="ButtonType.SUBMIT"
      [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      [text]="'SERVICE_FORMS.serviceForms.joinCorporateForm.summary.submit' | finLocalization"
      [icon]="submitIcon"
      (clickBtn)="submitForm()"
    ></fcom-button>
  </div>

  <fcom-notification *ngIf="formStatus === FormStatus.ERROR" class="mr-medium-y" [theme]="NotificationTheme.ALERT">
    {{ 'errors.generic.title' | finLocalization }}
  </fcom-notification>

  <fcom-notification *ngIf="formStatus === FormStatus.PRECONDITION_REQUIRED" class="mr-medium-y">
    {{ 'SERVICE_FORMS.serviceForms.preconditionRequired' | finLocalization }}
  </fcom-notification>
</div>

<div *ngIf="page === Page.ThankYou">
  <h2 class="ms-medium-b font-heading-2">
    {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.thankYouPage.title' | finLocalization }}
  </h2>
  <p>{{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.thankYouPage.text1' | finLocalization }}</p>
  <p>{{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.thankYouPage.text2' | finLocalization }}</p>
  <p>{{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.thankYouPage.regards' | finLocalization }}</p>
  <p class="bold-type">{{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.thankYouPage.team' | finLocalization }}</p>
  <div class="flex flex--end ms-xlarge-t">
    <a class="btn bold-type no-underline" [finLink]="returnLink$ | async">
      {{ 'SERVICE_FORMS.serviceForms.joinCorporateForm.thankYouPage.returnButton' | finLocalization }}
    </a>
  </div>
</div>

<ng-template #summaryField let-header="header" let-value="value">
  <div class="mr-xxsmall-b">
    <span class="font-body-1 block">{{ header }}</span>
    <span class="font-body-1 bold-type">{{ value || '-' }}</span>
  </div>
</ng-template>

<ng-template #pageNavigator let-currentPage="currentPage">
  <div class="border-top flex flex--end ms-xxlarge-t ps-xxlarge-t">
    <ng-container *ngIf="!editMode">
      <fcom-button
        *ngIf="currentPage > Page.CompanyInformation"
        class="ms-large-r"
        (clickBtn)="previousPage()"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'carousel.previous' | finLocalization"
      ></fcom-button>
      <fcom-button (clickBtn)="nextPage()" [text]="'carousel.next' | finLocalization"></fcom-button>
    </ng-container>
    <ng-container *ngIf="editMode">
      <fcom-button
        class="ms-large-r"
        [text]="'actions.cancel' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        (clickBtn)="cancel()"
      ></fcom-button>
      <fcom-button [text]="'actions.save' | finLocalization" (clickBtn)="changePage(Page.Summary)"></fcom-button>
    </ng-container>
  </div>
</ng-template>
